/**
 * @file Infoc上报内置项目Map
 * @author yuanliukai@cmcm.cm
 * @createDate 2020-11-10
 */
import { getParamsByUrl } from '../base'
import { getDeviceInfo } from '../device'

const isServer = typeof window === 'undefined'

const locSearch = isServer ? '' : window.location.search
const urlParams = locSearch ? getParamsByUrl(locSearch) : ''

// 获取设备信息
const device = isServer ? {} : getDeviceInfo()

// 浏览器可视分辨率width
const clientWidth = isServer ? 0 : document.body.clientWidth
// 屏幕宽度
const screenWidth = isServer ? 0 : window.screen.width

// 协议
const protocol = isServer ? '' : window.location.protocol

// infoc上报地址
const httpUrl = 'http://infoc2.duba.net/g/v1/'

/**
 * @constant {json}
 * @desc 毒霸项目Map，用于Infoc类的实例
 */
export const dubaMap = {
  httpUrl: httpUrl,
  httpsUrl: 'https://helpduba1.ksmobile.com/g/v1/',
  params: {
    product_no: 1,
    public_index: 6,
    business_index: 0,

    uuid: '',
    tid1: 0,
    tid2: 0,
    tod1: 0,
    tod2: 0,
    type: 0,
    tryno: 0,
    iid: 0,
    collect_time: 0,
    lastver: 0,
    svrid: '',
    wtod2: '',
    usertype_public: 0
  }
}

/**
 * @constant {json}
 * @desc 导航商业项目Map，用于Infoc类的实例（二级站dhsite_）
 */
export const daohangMap = {
  httpUrl: httpUrl,
  httpsUrl: 'https://helpdhsite2.ksmobile.com/g/v1/',
  params: {
    product_no: 131,
    public_index: 1,
    business_index: 0,

    uuid: '',
    dbid: '',
    lbid: '',
    url: locSearch,
    channel: urlParams.f || '',
    br: device.browser === 'Unknown' ? '' : device.browser,
    brv: device.bver === 'Unknown' ? '' : device.browser,
    os: device.sver === 'Unknown' ? '' : device.browser,
    referer: isServer ? '' : document.referrer
  }
}
/**
 * @constant {json}
 * @desc 导航商业项目Map，用于Infoc类的实例（导航daohang_）
 */
export const daohangSelfMap = {
  httpUrl: httpUrl,
  httpsUrl: 'https://helpdaohang1.ksmobile.com/g/v1/',
  params: {
    product_no: 201,
    public_index: 1,
    business_index: 0,

    mhour: '', // 上报产生的时间（hh:mm:ss）
    account: '', // 用户ID
    tp: '', // 导航版本
    br: device.browser === 'Unknown' ? '' : device.browser, // 浏览器名称
    brv: device.bver === 'Unknown' ? '' : device.browser, // 浏览器版本号
    useragent: '', //  浏览器ua
    refer: isServer ? '' : document.referrer, // 页面来源
    url: locSearch, // 产生上报页面的url
    channel: urlParams.f || '', // 导航渠道
    channel_dup: '', // 导航渠道(大类)
    lbpid: '', // 猎豹pid渠道号
    tryno: 0, // 毒霸版本
    tid1: 0, // 毒霸推广渠道号（url拆分）
    tid2: 0, // 毒霸推广渠道号（url拆分）
    tod1: 0, // 毒霸推广渠道号（url拆分）
    tod2: 0, // 毒霸推广渠道号（url拆分）
    pid: '', // 驱动精灵pid渠道号（url拆分）
    dis_body: clientWidth + '', // 窗口分辨率
    dis_pc: screenWidth + '', // pc分辨率
    uuid: '', // 客户端uuid
    lbid: '', // 猎豹浏览器自有id
    svrid: '', // 客户端通用用户标识id
    type: protocol, // 协议类型（http/https）
    size: clientWidth + '', // 窗口宽度
  }
}

/**
 * @constant {json}
 * @desc CM项目Map，用于Infoc类的实例
 */
export const cmMap = {
  httpUrl: httpUrl,
  httpsUrl: 'https://helpf.ksmobile.com/g/v1/',
  params: {
    product_no: 11,
    public_index: 14,
    business_index: 0,

    uuid: '',
    ver: 0, // ver 程序版本
    mcc: 0, // mcc
    mnc: 0, // mnc
    cl: '', // 语言
    cn: 0, // 渠道号
    prodid: 0, // 产品类型
    xaid: '', // 安卓ID
    uptime: 0, // 生成时间
    root2: 0, // Root权限
    capi: 0, // commonapi
    brand2: '', // 手机品牌
    model2: '', // 手机型号
    serial2: '', // 机器序列号
    cn2: '', // 辅助渠道号
    rom: '', // 系统Rom类型（如miui/flyme）
    rom_ver: '', // 系统Rom版本号（如v5/1.2.0）
    host_ver: 0, // CM宿主版本号,示例：10100014
    plugin_vers: '', // 插件的版本号，多插件时使用拼接方式上报。示例：10010216071201;10010316071305
    built_chnelid: '', // CM宿主构建渠道号，示例：100003
    utc: 0, // 时区
    iid: 0, // apk构建时间戳
    accountid: '' // 账号id
  }
}

/**
 * @constant {json}
 * @desc 猎豹浏览器项目Map，用于Infoc类的实例
 */
export const liebaoMap = {
  httpUrl: httpUrl,
  httpsUrl: 'https://helpliebao1.ksmobile.com/g/v1/',
  params: {
    product_no: 106,
    public_index: 2,
    business_index: 0,

    // 使用此业务需要自己传入 duba_uuid值 进行覆盖
    duba_uuid: '',
    uuid: '',
    pid: '',
    spid: '',
    tid1: 0,
    tid2: 0,
    tod1: 0,
    tod2: 0,
    lbver: '',
    tryno: 0,
    iid: 0,
    svrid: '',
    os: 0,
    ie: 0,
    wtod2: '',
    usertype_public: 0
  }
}

/**
 * @constant {json}
 * @desc 驱动精灵项目Map，用于Infoc类的实例
 */
export const qdjlMap = {
  httpUrl: httpUrl,
  httpsUrl: 'https://helpduba1.ksmobile.com/g/v1/',
  params: {
    product_no: 7,
    public_index: 3,
    business_index: 0,

    uuid: '',
    pg_version: '',
    os_version: '',
    os_architecture: '',
    pid: 0,
    mac: '',
    trynum: 0,
    svrid: '',
    wtod2: '',
    usertype_public: 0
  }
}

/**
 * @constant {json}
 * @desc 桌面壁纸项目Map，用于Infoc类的实例
 */
export const desktopMap = {
  httpUrl: httpUrl,
  httpsUrl: 'https://helpdhsite2.ksmobile.com/g/v1/',
  params: {
    product_no: 80,
    public_index: 1,
    business_index: 0,

    uuid: '',
    tid1: 0,
    tid2: 0,
    tod1: 0,
    tod2: 0,
    type: 0,
    tryno: 0,
    iid: 0,
    lastver: 0,
    svrid: '',
    wtod2: ''
  }
}
